import { render, staticRenderFns } from "./MateriaTitolo.vue?vue&type=template&id=7779f4d8"
import script from "./MateriaTitolo.vue?vue&type=script&lang=js"
export * from "./MateriaTitolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports